// extracted by mini-css-extract-plugin
module.exports = {"editor":"editor-pcTBU","mentionSuggestions":"mentionSuggestions-RVQYj","show_delay":"show_delay-TohPz"};